export function Logo({ className = "" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="var(--foreground)" />
      <path d="M14 41a18 18 0 1 1 36 0" fill="none" stroke="var(--background)" strokeWidth="4.5" strokeLinecap="round" />
      <line x1="32" y1="41" x2="44" y2="26" stroke="var(--primary)" strokeWidth="4.5" strokeLinecap="round" />
      <circle cx="32" cy="41" r="4" fill="var(--primary)" />
    </svg>
  );
}
